import React from 'react'

interface Props {
  openScene: boolean,
  showCollapse: boolean
}

interface State {
  showCollapseMenu: boolean
  firstTimeShowed: boolean
}

class Collapse extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {
      showCollapseMenu: false,
      firstTimeShowed: true
    }
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
    /*if(prevProps.openScene !== this.props.openScene && !this.props.openScene){
      this.setState({
        firstTimeShowed: true //si se desea que se muestre con cada auto
      })
    }

    /*if(prevProps.showCollapse !== this.props.showCollapse){
    if(prevProps.showCollapse !== this.props.showCollapse){
      if(this.state.firstTimeShowed && this.props.showCollapse){
        setTimeout(() => {
          this.setState({
            showCollapseMenu: true,
            firstTimeShowed: false
          })
        }, 1000)
      }
      if (!this.props.showCollapse){
        this.setState({
          showCollapseMenu: false
        })
      }
    }*/
    if(prevProps.openScene !== this.props.openScene && this.props.openScene){
      setTimeout(() => {
        this.setState({
          showCollapseMenu: true,
        })
      }, 1000)
    }

    if (prevProps.showCollapse !== this.props.showCollapse){
      this.setState({
        showCollapseMenu: false
      })
    }
  }
  
  render(): React.ReactNode {
      return null;
  }
}

export default Collapse